import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { Overview } from './components/Dashboard/Overview';
import { DashboardLayout } from './components/Dashboard/DashboardLayout';
import { AccountingRoutes } from './routes/AccountingRoutes';
import { Reports } from './components/Reports/Reports';
import { Compliance } from './components/Compliance/Compliance';
import { Grants } from './components/Grants/Grants';
import { Settings } from './components/Settings/Settings';
import './styles/global.css';
import { ServiceProvider } from './contexts/ServiceProvider';
import { 
  ReportsProps, 
  ComplianceProps, 
  GrantsProps, 
  SettingsProps 
} from './types/props';
import { Form990Provider } from './contexts/Form990Context';

const DashboardLayoutWrapper: React.FC = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export const SponsFIApp: React.FC = () => {
  const fiscalSponsorId = "your-sponsor-id"; // Replace with actual ID source

  return (
    <Form990Provider>
      <ServiceProvider>
        <Routes>
          <Route element={<DashboardLayoutWrapper />}>
            <Route path="/sponsfi/overview" element={<Overview fiscalSponsorId={fiscalSponsorId} />} />
            <Route path="/sponsfi/accounting/*" element={<AccountingRoutes />} />
            <Route path="/sponsfi/reports" element={<Reports fiscalSponsorId={fiscalSponsorId} />} />
            <Route path="/sponsfi/compliance" element={<Compliance fiscalSponsorId={fiscalSponsorId} />} />
            <Route path="/sponsfi/grants" element={<Grants fiscalSponsorId={fiscalSponsorId} />} />
            <Route path="/sponsfi/settings" element={<Settings fiscalSponsorId={fiscalSponsorId} />} />
            
            {/* Default Route */}
            <Route path="/" element={<Overview fiscalSponsorId={fiscalSponsorId} />} />
          </Route>
        </Routes>
      </ServiceProvider>
    </Form990Provider>
  );
};

export default SponsFIApp;
